<div *ngIf="parentApplicationId" class="app-status">
  <h3 class="title">Status</h3>
  <div
    *ngIf="isLoading"
    class="d-flex align-items-center justify-content-center text-center py-5">
    <output>
      <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem">
        <span class="visually-hidden">Loading...</span>
      </div>
    </output>
  </div>
  <div *ngIf="!isLoading && childApplications && childApplications.length > 0">
    <ol class="timeline">
      <li
        *ngFor="let application of childApplications; let index = index"
        class="step-item">
        <div class="step-icon-container">
          <div
            class="step-icon"
            [class.blue-dot]="
              application.applicationStatus === 'PAYMENT_PENDING'
            ">
            <img
              *ngIf="application.applicationStatus !== 'PAYMENT_PENDING'"
              src="assets/icons/status-check.svg"
              alt="" />
          </div>
        </div>

        <div class="step-content">
          <!-- Application Content -->
          <div class="app-content-wrapper">
            <!-- Row 1: Service Name and Action Buttons -->
            <div class="row-1">
              <div class="application-title">
                {{ application.serviceName || 'Application' }}
              </div>

              <!-- Application Actions Section -->
              <div class="app-actions-section">
                <!-- Completed Applications -->
                <div
                  *ngIf="application.applicationStatus !== 'PAYMENT_PENDING'"
                  class="action-buttons"
                  [class.single-button]="
                    !(
                      application &&
                      application?.paymentStatus === 'PAID' &&
                      !isSelectedApplicationFree(application)
                    ) ||
                    !(
                      application.officerAttachments &&
                      applicationCertificates(application).length > 0
                    )
                  ">
                  <!-- Certificate Dropdown -->
                  <div
                    *ngIf="
                      viewFullDetails &&
                      application.officerAttachments &&
                      applicationCertificates(application).length > 0
                    "
                    class="dropdown certificate-dropdown">
                    <button
                      #certificateDropdown
                      class="btn download-btn dropdown-toggle"
                      type="button"
                      id="certificateDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      (click)="$event.stopPropagation()">
                      {{ 'Download Certificate' | translate }}
                    </button>
                    <ul
                      class="dropdown-menu dropdown-menu-end certificate-menu"
                      aria-labelledby="certificateDropdown">
                      <li class="dropdown-header">
                        {{ 'AVAILABLE CERTIFICATES' | translate }}
                      </li>
                      <hr />
                      <li
                        *ngFor="
                          let certificate of applicationCertificates(
                            application
                          )
                        ">
                        <a
                          class="dropdown-item"
                          (click)="downloadAttachment(certificate)">
                          <span class="certificate-name text-truncate">{{
                            certificate.fileName | translate
                          }}</span>
                          <i
                            *ngIf="
                              !(
                                downloadingAttachmentsByOtp ||
                                isDownloadingCertificate
                              )
                            "
                            class="fa fa-download"></i>
                          <i
                            *ngIf="
                              downloadingAttachmentsByOtp ||
                              isDownloadingCertificate
                            "
                            class="fa fa-spinner fa-spin"></i>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- Receipt Button -->
                  <button
                    *ngIf="
                      application &&
                      application?.paymentStatus !== 'PAYMENT_PENDING' &&
                      !isSelectedApplicationFree(application) &&
                      viewFullDetails
                    "
                    class="btn download-btn"
                    (click)="
                      downloadReceipt(application?.applicationNumber);
                      $event.stopPropagation()
                    ">
                    <span *ngIf="!downloadingReceipt">
                      {{ 'Download Receipt' | translate }}
                    </span>
                    <span *ngIf="downloadingReceipt || downloadingRecieptByOtp">
                      <i class="fa fa-spinner fa-spin"></i>
                      {{ 'Receipt downloading' | translate }}
                    </span>
                  </button>
                </div>

                <!-- Payment Button -->
                <div
                  *ngIf="application.applicationStatus === 'PAYMENT_PENDING'"
                  class="payment-button">
                  <button
                    (click)="
                      makePayment(application.merchant, application.billId);
                      $event.stopPropagation()
                    "
                    class="btn btn-primary pay-now-btn">
                    {{ 'Pay now' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Row 2: Application Status -->
            <div class="row-2">
              <div
                class="application-status irembo-badge"
                [ngClass]="
                  getApplicationStatusToColor(application.applicationStatus)
                ">
                <div
                  class="pulse"
                  [ngClass]="
                    getApplicationStatusPulseToBackgroundColor(
                      application.applicationStatus
                    )
                  "></div>
                <span *ngIf="!application.applicationStatusNames">{{
                  getApplicationStatusToLabel(application.applicationStatus)
                    | translate
                }}</span>
                <span *ngIf="application.applicationStatusNames">{{
                  application.applicationStatusNames[this.locale] ??
                    getApplicationStatusToLabel(application.applicationStatus)
                    | translate
                }}</span>
              </div>
            </div>

            <!-- Row 3: Application Number, Date, and View Details Button -->
            <div class="row row-3">
              <div class="col-md-4">
                <p class="text-muted mb-1">
                  {{ 'Application No' | translate }}
                </p>
                <p class="w-bold">{{ application.applicationNumber }}</p>
              </div>
              <div class="col-md-4">
                <p class="text-muted mb-1">{{ 'Last Updated' | translate }}</p>
                <p class="w-bold">
                  {{
                    application.lastUpdated
                      ? (convertDate(application.lastUpdated)
                        | date : 'MMM d, yyyy h:mm a')
                      : '-'
                  }}
                </p>
              </div>
              <div class="col-md-4 d-flex align-items-end justify-content-end">
                <!-- View Details Button -->
                <button
                  *ngIf="shouldShowViewDetailsButton()"
                  (click)="
                    toggleChildDetails(application.applicationNumber);
                    $event.stopPropagation()
                  "
                  class="btn btn-link text-decoration-none view-details-btn"
                  type="button">
                  <span>{{ 'View Details' | translate }}</span>
                  <i
                    class="icon"
                    [ngClass]="{
                      'icon-chevron-down': !isChildExpanded(
                        application.applicationNumber
                      ),
                      'icon-chevron-up': isChildExpanded(
                        application.applicationNumber
                      )
                    }"></i>
                </button>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              getActiveFeedbacks(application.applicationNumber).length &&
              application.applicationStatus.includes('PENDING_RESUBMISSION')
            "
            class="child-feedback">
            <irembogov-officer-comment
              *ngFor="
                let feedback of getActiveFeedbacks(
                  application.applicationNumber
                );
                trackBy: trackChildFeedback
              "
              [label]="'Officer Comment' | translate"
              [comment]="feedback.comment || ''">
            </irembogov-officer-comment>
          </div>

          <!-- Expanded Details Section -->
          <div
            *ngIf="isChildExpanded(application.applicationNumber)"
            class="child-details-expanded">
            <!-- Loading State -->
            <div
              *ngIf="loadingChildDetails.has(application.applicationNumber)"
              class="loading-spinner">
              <output>
                <div
                  class="spinner-grow text-primary"
                  style="width: 3rem; height: 3rem"></div>
                <span class="visually-hidden">Loading...</span>
              </output>
            </div>

            <!-- Application Summary Component -->
            <irembogov-application-summary
              *ngIf="
                childSummariesMap.has(application.applicationNumber) &&
                !loadingChildDetails.has(application.applicationNumber)
              "
              [showTitle]="false"
              [application]="$any(application)"
              [applicationSummary]="
                childSummariesMap.get(application.applicationNumber)!
              "
              [applicationBaseUrl]="environment.apiGatewayBaseUrl"
              [applicationPath]="
                '/application/v1/file-manager/application/attachment'
              "
              [applicationOtp]="otp || ''">
            </irembogov-application-summary>

            <!-- Error State -->
            <div
              *ngIf="
                !childSummariesMap.has(application.applicationNumber) &&
                !loadingChildDetails.has(application.applicationNumber)
              "
              class="error-state">
              <p>{{ 'Unable to load application details' | translate }}</p>
            </div>
          </div>
        </div>
      </li>
    </ol>
  </div>
</div>
